import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { getNonWorkingHoursTimeFrames } from '../../../utils/nonWorkingHoursUtils'
import './PlanningNonWorkingHoursOverlay.scss'

export default class PlanningNonWorkingHoursOverlay extends PureComponent {
  static propTypes = {
    startTime: PropTypes.object.isRequired,
    endTime: PropTypes.object.isRequired,
    nonWorkingHours: PropTypes.array.isRequired,
    config: PropTypes.object.isRequired,
    timeToScreen: PropTypes.func.isRequired
  }

  render() {
    // Set the initial values of the start the current month in viewport

    return (
      <div className="non-working-hours-overlay-wrapper">
        {this.props.nonWorkingHours.map((nonWorkingHours, nonWorkingHoursIndex) => {
          const nonWorkingHourTimeframes = getNonWorkingHoursTimeFrames(
            this.props.startTime,
            this.props.endTime,
            nonWorkingHours
          )

          return (
            <div key={nonWorkingHoursIndex}>
              {nonWorkingHourTimeframes.map((nonWorkingHourTimeframe, timeframeIndex) => {
                // Calculate the screen positions based on the nonWorkingHours start & endtimes
                const overlayTopPos = this.props.timeToScreen(nonWorkingHourTimeframe.startTime)
                const overlayBottomPos = this.props.timeToScreen(nonWorkingHourTimeframe.endTime)
                const overlayHeight = overlayBottomPos - overlayTopPos

                const overlayStyle = {
                  top: overlayTopPos,
                  height: overlayHeight
                }

                return (
                  <div key={timeframeIndex} className="non-working-hours-overlay" style={overlayStyle}>
                    <span className="text">Non-working hours</span>
                  </div>
                )
              })}
            </div>
          )
        })}
      </div>
    )
  }
}
